define('views/components/distributor/distributor',['require','backbone','text!templates/components/distributor/distributor.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/distributor/distributor.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'distributor-item'
    });
});
